import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { OrderMaterial, } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { FlorderEditMaterialComponent, TypeOptions } from 'app/modules/florder/florder-edit-material/florder-edit-material.component';
import { BehaviorSubject } from 'rxjs';
import { LayoutBreakpoints } from '../../../core/util/layout-breakpoints';

@Component({
  selector: 'app-order-edit-material',
  templateUrl: './order-edit-material.component.html',
  styleUrls: ['../../florder/florder-edit-material/florder-edit-material.component.scss'],
})
export class OrderEditMaterialComponent extends FlorderEditMaterialComponent<OrderMaterial> implements OnInit, OnChanges {
  typeOptions: any[];
  isMobilePortraitScreen$ = LayoutBreakpoints.matches(this.breakpointObserver, LayoutBreakpoints.minimumScreenOrLess);
  numberOfPalletsValidationErrorObject: BehaviorSubject<{ [key: string]: boolean }> = new BehaviorSubject(null);
  packingQuantityValidationErrorObject: BehaviorSubject<{ [key: string]: boolean }> = new BehaviorSubject(null);

  constructor(private breakpointObserver: BreakpointObserver) {
    super();
  }

  async ngOnInit() {
    await super.ngOnInit();
    this.registerFormSubscriptions();
    this.registerErrorObjectSubscriptions();
  }

  async ngOnChanges(changes: SimpleChanges) {
    await super.ngOnChanges(changes);
    this.calcTypeOptions();
    this.registerFormSubscriptions();
    this.registerErrorObjectSubscriptions();
  }

  resetForm() {
    const excludedControls = ['type', 'internalId', 'palletId'];
    for (const controlName in this.editMaterialForm.controls) {
      if (!excludedControls.includes(controlName)) {
        const currentValue = this.editMaterialForm.get(controlName).value;
        if (typeof currentValue !== 'boolean') {
          // field 'isNew' must remain false or true
          this.editMaterialForm.controls[controlName].setValue(' ');
        }
      }
    }
  }

  private registerFormSubscriptions() {
    this.editMaterialForm.valueChanges.subscribe((form) => {
      this.registerFormSubscriptionsType(form);
      this.registerFormSubscriptionsNumberOfPallets(form);
      this.registerFormSubscriptionsPackingQuantity(form);
    });
  }

  private registerFormSubscriptionsType(form: any) {
    if (form.type === TypeOptions.packing) {
      form.numberOfPallets = null;
    } else if (form.type === TypeOptions.pallet || form.type === TypeOptions.combination) {
      form.packingQuantity = null;
    }
  }

  private registerFormSubscriptionsNumberOfPallets(form: any) {
    if (form.numberOfPallets < 0) {
      const errorMessage = this.translateService.instant('ORDERS.MATERIAL.LABELS.ERRORS.NUMBER_OF_PALLETS');
      this.numberOfPalletsValidationErrorObject.next({ [errorMessage]: true });
    } else {
      this.numberOfPalletsValidationErrorObject.next(null);
    }
  }

  private registerFormSubscriptionsPackingQuantity(form: any) {
    if (form.packingQuantity < 0) {
      const errorMessage = this.translateService.instant('ORDERS.MATERIAL.LABELS.ERRORS.NUMBER_OF_PALLETS');
      this.packingQuantityValidationErrorObject.next({ [errorMessage]: true });
    } else {
      this.packingQuantityValidationErrorObject.next(null);
    }
  }

  private registerErrorObjectSubscriptions() {
    this.registerErrorObjectSubscriptionsNumberOfPallets();
    this.registerErrorObjectSubscriptionsPackingQuantity();
  }

  private registerErrorObjectSubscriptionsNumberOfPallets() {
    this.numberOfPalletsValidationErrorObject.subscribe((error) => {
      if (error) {
        this.editMaterialForm.get('numberOfPallets').setErrors(error);
      } else {
        this.editMaterialForm.get('numberOfPallets').setErrors(null);
      }
    });
  }

  private registerErrorObjectSubscriptionsPackingQuantity() {
    this.packingQuantityValidationErrorObject.subscribe((error) => {
      if (error) {
        this.editMaterialForm.get('packingQuantity').setErrors(error);
      } else {
        this.editMaterialForm.get('packingQuantity').setErrors(null);
      }
    });
  }

  private calcTypeOptions() {
    this.typeOptions = [
      { id: TypeOptions.packing, name: 'ORDERS.MATERIAL.LABELS.TYPES.PACKING', disabled: !(this.materialTypes?.packings?.length > 0) },
      { id: TypeOptions.pallet, name: 'ORDERS.MATERIAL.LABELS.TYPES.PALLET', disabled: !(this.materialTypes?.pallets?.length > 0) },
      { id: TypeOptions.combination, name: 'ORDERS.MATERIAL.LABELS.TYPES.COMBO', disabled: !(this.materialTypes?.combination?.palletIds?.length > 0) },
    ]
  }
}
